import { PATHNAMES } from 'utils/routes/consts'

import type { Macroarea } from './types'

export const MACROAREAS = [
  {
    macroarea: 'New Home',
    pathname: '/',
  },
  {
    macroarea: 'New Home',
    pathname: '/panel/:panelId',
  },
  {
    macroarea: 'New Home',
    pathname: '/panel/:panelId/:tab?',
  },
  {
    macroarea: 'Login',
    pathname: '/login',
  },
  {
    macroarea: 'Topics',
    pathname: '/topics/:topicsType',
  },
  {
    macroarea: 'Topics',
    pathname: '/topic/:entityId/:tab?',
  },
  {
    macroarea: 'Creator',
    pathname: '/group/:groupId/:creatorId/:provider/:tab?',
  },
  {
    macroarea: 'Video',
    pathname: '/post/:provider/:postId',
  },
  {
    macroarea: 'Video',
    pathname: '/sharedPost?shareToken=token',
  },
  {
    macroarea: 'Compare',
    pathname: '/compare/:tab?',
  },
  {
    macroarea: 'Subtopics',
    pathname: '/subtopic/:entityId/:tab?',
  },
  {
    macroarea: 'Jobs',
    pathname: '/jobs?:filters?',
  },
  {
    macroarea: 'Jobs',
    pathname: PATHNAMES.DASHBOARDS_FOLDER,
  },
  {
    macroarea: 'Jobs',
    pathname: '/jobs',
  },
  {
    macroarea: 'Reports',
    pathname: '/reports',
  },
  {
    macroarea: 'Reports',
    pathname: '/reports/all/:postId?',
  },
  {
    macroarea: 'Reports',
    pathname: '/reports/custom/:postId?',
  },
  {
    macroarea: 'Reports',
    pathname: '/reports/recurrent/:postId?',
  },
  {
    macroarea: 'Video',
    pathname: '/trending/trending-tag/:entityId/:tab?',
  },
  // search
  {
    macroarea: 'Creator',
    pathname: '/search/creator',
  },
  {
    macroarea: 'Creator',
    pathname: '/search/creator?:searchQuery?',
  },
  {
    macroarea: 'Video',
    pathname: '/search/video',
  },
  {
    macroarea: 'Video',
    pathname: '/search/video?:searchQuery?',
  },
  // end search
  {
    macroarea: 'My account',
    pathname: '/my-account/personal-infos',
  },
  {
    macroarea: 'Members & Teams',
    pathname: '/members-and-teams',
  },
  {
    macroarea: 'Members & Teams',
    pathname: '/members-and-teams/invite',
  },
  {
    macroarea: 'Members & Teams',
    pathname: '/members-and-teams/edit',
  },
  {
    macroarea: 'Members & Teams',
    pathname: '/members-and-teams/remove',
  },
  // workspace
  {
    macroarea: 'Video',
    pathname: '/workspace/:panelId/saved-search/:entityId/:tab?',
  },
  {
    macroarea: 'Job',
    pathname: '/workspace/:panelId/jobs/:jobId/:tab/:folder?/:subTab?',
  },
  {
    macroarea: 'Brand',
    pathname: '/workspace/:panelId/brands/:tab?',
  },
  {
    macroarea: 'Brand',
    pathname: '/workspace/:panelId/brand/:entityId/:tab?',
  },
  {
    macroarea: 'Brand',
    pathname: PATHNAMES.WORKSPACE_BRAND_OVERVIEW,
  },
  {
    macroarea: 'Brand Group',
    pathname: '/workspace/:panelId/brand-group/:entityId/:tab?',
  },
  {
    macroarea: 'Category',
    pathname: '/workspace/:panelId/category',
  },
  {
    macroarea: 'Category',
    pathname: '/workspace/:panelId/category/ranking',
  },
  {
    macroarea: 'Share of Attention',
    pathname: '/workspace/:panelId/share-of-attention',
  },
  {
    macroarea: 'Share of Attention',
    pathname: '/workspace/:panelId/share-of-attention/ranking',
  },
  {
    macroarea: 'Topics',
    pathname: '/workspace/:panelId/niche/:entityId/:tab?',
  },
  {
    macroarea: 'Topics',
    pathname: PATHNAMES.WORKSPACE_CATEGORY_NICHE,
  },
  // new future urls
  {
    macroarea: 'New Home',
    pathname: '/workspace/:panelId/new',
  },
  {
    macroarea: 'New Home',
    pathname: '/workspace/:panelId',
  },
  {
    macroarea: 'Category',
    pathname: '/workspace/:panelId/zai',
  },
  {
    macroarea: 'Category',
    pathname: '/workspace/:panelId/zai/answer',
  },
  {
    macroarea: 'Creator',
    pathname: '/workspace/:panelId/search/creator?:searchQuery?',
  },
  {
    macroarea: 'Creator',
    pathname: '/workspace/:panelId/search/creator',
  },
  {
    macroarea: 'Video',
    pathname: '/workspace/:panelId/search/video?:searchQuery?',
  },
  {
    macroarea: 'Video',
    pathname: '/workspace/:panelId/search/video',
  },
  {
    macroarea: 'Compare',
    pathname: '/workspace/:panelId/compare/:tab?',
  },
  {
    macroarea: 'Creator',
    pathname: '/workspace/:panelId/group/:groupId/:creatorId/:provider/:tab?',
  },
  {
    macroarea: 'Creator',
    pathname: '/creator/:creatorId/:provider/:tab?',
  },
  {
    macroarea: 'Video',
    pathname: '/workspace/:panelId/post/:provider/:postId',
  },
  {
    macroarea: 'Jobs',
    pathname: '/workspace/:panelId/dashboards',
  },
  {
    macroarea: 'Reports',
    pathname: '/workspace/:panelId/reports',
  },
  {
    macroarea: 'Reports',
    pathname: '/workspace/:panelId/reports/all/:postId?',
  },
  {
    macroarea: 'Reports',
    pathname: '/workspace/:panelId/reports/custom/:postId?',
  },
  {
    macroarea: 'Reports',
    pathname: '/workspace/:panelId/reports/recurrent/:postId?',
  },
  {
    macroarea: 'Reports',
    pathname: '/workspace/:panelId/reports/dashboard/:dashboardId',
  },
  {
    macroarea: 'Topics',
    pathname: '/workspace/:panelId/topics/:topicsType',
  },
  {
    macroarea: 'Topics',
    pathname: '/workspace/:panelId/topic/:entityId/:tab?',
  },
  {
    macroarea: 'Topics',
    pathname: '/workspace/:panelId/trending/:entityId/:tab?',
  },
  {
    macroarea: 'Subtopics',
    pathname: '/workspace/:panelId/subtopic/:entityId/:tab?',
  },
  {
    macroarea: 'Industry Category',
    pathname: PATHNAMES.INDUSTRY_CATEGORY,
  },
  {
    macroarea: 'Hot Topics',
    pathname: PATHNAMES.WORKSPACE_HOT_TOPIC,
  },
  {
    macroarea: 'Global Topic',
    pathname: PATHNAMES.WORKSPACE_GLOBAL_TOPIC,
  },
  {
    macroarea: 'Theme',
    pathname: PATHNAMES.WORKSPACE_THEME,
  },
  {
    macroarea: 'Segment',
    pathname: PATHNAMES.WORKSPACE_SEGMENT,
  },
  {
    macroarea: 'Subject',
    pathname: PATHNAMES.WORKSPACE_SUBJECT,
  },
  {
    macroarea: 'Entity Query',
    pathname: PATHNAMES.WORKSPACE_ENTITY_QUERY,
  },
  {
    macroarea: 'Entity',
    pathname: PATHNAMES.WORKSPACE_ENTITY,
  },
  {
    macroarea: 'Video',
    pathname: '/workspace/:panelId/trending/trending-tag/:entityId/:tab?',
  },
  {
    macroarea: 'Tags Monitor',
    pathname: PATHNAMES.WORKSPACE_TAGS,
  },
  {
    macroarea: 'Tags Monitor',
    pathname: PATHNAMES.WORKSPACE_TAG,
  },
  // end workspace
  {
    macroarea: 'Public dashboard',
    pathname: '/public/dashboard/:dashboardId',
  },
  {
    macroarea: 'Reports',
    pathname: '/reports/dashboard/:dashboardId',
  },
  {
    macroarea: 'Setup',
    pathname: '/onboarding',
  },
  {
    macroarea: 'Onboarding',
    pathname: '/getting-started',
  },
  {
    macroarea: 'Category',
    pathname: '/zai',
  },
  {
    macroarea: 'Category',
    pathname: '/zai/answer',
  },
  {
    macroarea: 'Trends',
    pathname: PATHNAMES.WORKSPACE_TRENDS,
  },
  {
    macroarea: 'Live Events',
    pathname: PATHNAMES.WORKSPACE_LIVE_EVENTS,
  },
  {
    macroarea: 'Live Events',
    pathname: PATHNAMES.WORKSPACE_LIVE_EVENT,
  },
] as const satisfies { pathname: string; macroarea: Macroarea }[]
